import TextHighlighter from "../../common/searchbar/TextHighlighter";
import {Link} from "react-router-dom";
import {messages} from "../../common/Translations";
import {injectIntl} from "react-intl";
import React from "react";


const ArticleCategoryTableRow = ({category, categoryOptions, onChangeCategory, onDelete, loginAs, listId, onRestore, adminCompanyId, showPortals, intl}) => {

    let hideDeleteButton = category.deleted;
    let hideReactivateButton = !category.deleted;

    return (
        <tr data-cy-list-row-id={category.id} key={category.id}>
            <td scope="row" className="align-middle">{category.id}</td>
            <td className="align-middle">{category.name}</td>
            <td className="align-middle">{category.portal !== null ? category.portal.name : intl.formatMessage(messages.articleCategoryListPortalNotAssigned)}</td>
            <td className="align-middle">{category.description}</td>
            <td hidden={category.deleted}>
                <span className="badge badge-success">{intl.formatMessage(messages.articleCategoryStatusActive)}</span>
            </td>
            <td hidden={!category.deleted}>
                <span className="badge badge-danger">{intl.formatMessage(messages.articleCategoryStatusDeactivated)}</span>
            </td>
            <td className="list-actions text-right align-middle">
                <div className="btn-group text-right">
                    <Link to={'/kategorier/nyheder/redigere/' + category.id}
                          className="btn btn-secondary waves-effect list-action"
                    >
                        <i className="fa fa-pencil"/>{intl.formatMessage(messages.listDropDownButtonEdit)}
                    </Link>
                    <button
                        type="button"
                        className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                        data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                    </button>

                    <div className="dropdown-menu">
                        <button
                            hidden={hideDeleteButton}
                            type="button"
                            className="dropdown-item clickable"
                            onClick={() => onDelete(category)}
                            data-delete-action
                        >
                            <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                        </button>
                        <button
                            hidden={hideReactivateButton}
                            type="button"
                            className="dropdown-item clickable"
                            data-delete-action
                            onClick={() => onRestore(category.id)}

                        >
                            <i className="fa fa-undo"/> {intl.formatMessage(messages.articleCategoryStatusReactivate)}
                        </button>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default injectIntl(ArticleCategoryTableRow);



// WEBPACK FOOTER //
// ./web/src/components/articles/category/ArticleCategoryTableRow.jsx